import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Select from "antd/lib/select";
import "antd/lib/select/style/index.js";
import styles from './MultiSelect.module.less';
const MultiSelect = ({ name, value = [], onChange, options, placeholder = 'Select all that apply', className }) => {
    const toggleOption = (val) => {
        const updated = value.includes(val)
            ? value.filter(v => v !== val)
            : [...value, val];
        onChange(updated);
    };
    return (_jsx(Select, { id: name, mode: "multiple", style: { width: '100%' }, placeholder: placeholder, value: value, onChange: onChange, className: className, showArrow: true, options: options.map(([value, label]) => ({ value, label })), dropdownRender: () => (_jsx("div", { className: styles['multiSelect-dropdown'], children: options.map(([optValue, optLabel]) => (_jsxs("label", { className: styles['multiSelect-option'], children: [_jsx("input", { type: "checkbox", checked: value.includes(optValue), onChange: () => toggleOption(optValue) }), optLabel] }, optValue))) })) }));
};
export default MultiSelect;
